import CrmServiceModel from "@/models/CrmServiceModel";
import CustomerModel from "@/models/crm/CustomerModel";
import CustomerLocationModel from "@/models/crm/CustomerLocationModel";

export default class CustomerContactModel extends CrmServiceModel {

  modelName() {
    return 'customer-contacts';
  }

  publicRoutes() {
    let routes = super.publicRoutes() || {};
    routes.create = process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/'/* + 'public/'*/ + this.modelName();
    routes.exists = process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/public/' + this.modelName() + '/exists';
    return routes;
  }

  defaults() {
    return {
      id: null,
      customer_id: null,
      customer: null,
      customer_location_id: null,
      customer_location: null,
      user_id: null,
      user: null,
      name: null,
      phone_number: null,
      email: null,
      role: null,
      is_primary: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      customer_id: (val) => (this.nullStringMutator(val)),
      customer_location_id: (val) => (this.nullStringMutator(val)),
      user_id: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      phone_number: (val) => (this.nullStringMutator(val)),
      email: (val) => (this.nullStringMutator(val)),
      role: (val) => (this.nullStringMutator(val)),
      is_primary: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  routes() {
    let base_route = process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/';
    let routes = super.routes();
    routes.exists = base_route + this.modelName() + '/exists';
    return routes;
  }

  exists() {
    let payload = this.attributes;
    let config = {
      method: this.getMethod('create'),
      url: this.getURL(this.getRoute('exists')),
      data: payload
    };
    return this.createRequest(config).send().then((response) => {
      if(response.response.status === 200) {
        return true;
      } else if(response.response.status === 204) {
        return false;
      }
    });
  }

  getCustomer() {
    return this.getRelatedModel(CustomerModel, 'customer');
  }

  getCustomerLocation() {
    return this.getRelatedModel(CustomerLocationModel, 'customer_location');
  }
}
